'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/eval.js
// module id = 1539
// module chunks = 8